import { useSearchParams } from "react-router-dom";
import {
  ExternalDoorReplacementGeneralInformation,
  ExternalDoorReplacementInstallationInformation,
  ExternalDoorReplacementMeasurementValues,
} from "./components";

interface ExternalDoorReplacementType {
  setStep: (page: number) => void;
  step: number;
  measurementInfo: any;
  prevStep: () => void;
}

const ExternalDoorReplacement = ({
  step,
  setStep,
  measurementInfo,
  prevStep,
}: ExternalDoorReplacementType) => {
  const [searchParams] = useSearchParams();
  const measurementUuid = searchParams.get("measurementUuid");

  const handleShowForm = (step: number, measurementUuid: string | null) => {
    switch (step) {
      case 2:
        return (
          <ExternalDoorReplacementGeneralInformation
            setStep={setStep}
            step={step}
            measurementInfo={measurementInfo}
            measurementUuid={measurementUuid}
            prevStep={prevStep}
          />
        );
      case 3:
        return (
          <ExternalDoorReplacementInstallationInformation
            setStep={setStep}
            step={step}
            measurementInfo={measurementInfo}
            measurementUuid={measurementUuid}
            prevStep={prevStep}
          />
        );
      case 4:
        return (
          <ExternalDoorReplacementMeasurementValues
            setStep={setStep}
            step={step}
            measurementInfo={measurementInfo}
            measurementUuid={measurementUuid}
            prevStep={prevStep}
          />
        );
      default:
        return null;
    }
  };

  return handleShowForm(step, measurementUuid);
};

export default ExternalDoorReplacement;
